module.exports = __webpack_public_path__ + "img/kg.821b97a4.svg";